import moment from 'moment';
import { DATE_FORMAT_WITH_HOUR_MINS, displayDate, getNewDate, isDateBefore } from 'utils/date';
import { IntegrationStatusBadge } from '../../../../types';
import { StyledExpirationLabel } from '../IntegrationTable.styled';

type Props = {
  badges: IntegrationStatusBadge;
  dateTime: number;
  testPushSuccess?: boolean;
};

export const ExpirationLabel = ({ badges, dateTime, testPushSuccess }: Props) => {
  const expirationDate = moment(dateTime);
  const today = getNewDate();
  const hasExpired = isDateBefore(expirationDate, today);

  const badgeDiv = (badge: JSX.Element, appendId: string) => (
    <div data-test={`integration-table-badge-${appendId}`}>{badge}</div>
  );

  const getBadge = (expired: boolean, pushStatus?: boolean) => {
    if (expired) {
      return badgeDiv(badges.EXPIRED, 'expired');
    } else if (pushStatus !== undefined) {
      return pushStatus
        ? badgeDiv(badges.ACTIVE, 'active')
        : badgeDiv(badges.TEST_PUSH, 'test-push');
    }
    return badgeDiv(badges.ACTIVE, 'active');
  };

  return (
    <>
      {getBadge(hasExpired, testPushSuccess)}
      <StyledExpirationLabel data-test="integration-table-expiration-date">
        {`Expire${hasExpired ? 'd' : 's'} ${displayDate(
          expirationDate,
          DATE_FORMAT_WITH_HOUR_MINS,
        )}`}
      </StyledExpirationLabel>
    </>
  );
};
